<template>
  <div class="content" id="d1">
    <div class="main">
      <div class="top-type">
        <span>筛选：</span>
        <el-tabs v-model="sectionActive" @tab-click="handleClick">
          <el-tab-pane label="全部" name="0,0"></el-tab-pane>
          <el-tab-pane :label="item.label" :name="item.value" v-for="item in sectionList" :key="item.value">
          </el-tab-pane>
        </el-tabs>
        <el-select @change="changeYear(2)" v-model="term" placeholder="全部">
          <el-option v-for="item in this.termData" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select @change="changeYear(1)" v-model="year" placeholder="全部">
          <el-option v-for="item in this.yearData" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </div>
      <div class="select-d">
        <el-button type="primary" icon="el-icon-document" v-if="isSelf && identity.identity_status == 1"
          @click="addBtn()">写文章</el-button>
        <span @click="changeActive(1)" :class="active1">点击数排序</span>
        <span @click="changeActive(0)" :class="active2">时间排序</span>
      </div>

      <table>
        <tr class="first-tr">
          <td class="td1" width="350">标题</td>
          <td width="240">权限</td>
          <td width="120">浏览数</td>
          <td width="220">时间</td>
          <td width="120" v-if="isSelf">状态</td>
          <td width="280" v-if="userid == owner_id">操作</td>
        </tr>
        <div v-if="isShow" class="none">暂无统计数据</div>
        <tr class="second-tr" v-for="item in articleList" :key="item.id" v-else>
          <td class="td-1">
            <p @click="toInfo(item)" title="课程标题内容">{{item.title}}</p>
          </td>
          <td class="td-2 limit"
            :title="item.permission_scope == 1 ? item.cn_permission_scope: item.school_name + '校内'">
            {{item.permission_scope == 1 ? item.cn_permission_scope: item.school_name + "校内"}}</td>
          <td class="td-2">{{item.view_count}}</td>
          <td class="td-2">{{item.create_time}}</td>

          <span v-if="item.delete_by != 0 && isSelf">
            <td class="td-2" style="color:#797C81">已屏蔽</td>
          </span>
          <span v-if="item.delete_by == 0 && isSelf">
            <td v-if="item.approve_status == 1" class="td-2" style="color:#F3C22C">待审核</td>
            <td v-if="item.approve_status == 2" class="td-2" style="color:#33D86D">已通过</td>
            <td v-if="item.approve_status == 3" class="td-2" style="color:#D83333">未通过</td>
          </span>

          <td class="td-2 td-3" v-if="userid == owner_id">
            <el-button class="el-icon-edit-outline" style="border:none;background:#f6f9fa" :disabled="item.mode == 1"
              @click="download(item.file_url, item.file_name)">下载</el-button>
            <el-button class="el-icon-edit-outline" style="border:none;background:#f6f9fa"
              :disabled="role.owner_school != item.schoolid || identity.identity_status != 1" @click="editBtn(item)">编辑
            </el-button>
            <el-button class="el-icon-delete" style="border:none;background:#f6f9fa"
              :disabled="role.owner_school != item.schoolid || identity.identity_status != 1"
              @click="delArticleBtn(item)">删除</el-button>
          </td>
        </tr>
      </table>
      <el-pagination background layout="prev, pager, next" @current-change="PageChange" :current-page="this.page"
        :page-size="this.pageSize" :total="this.count" :hide-on-single-page="true"></el-pagination>
    </div>

    <!-- 发布文章 -->
    <el-dialog class="add_article_box" title="发布文章" :closeOnClickModal="false" :visible.sync="dialogVisible1"
      width="700px">
      <p class="p1">
        标题：
        <span style="color:red">*</span>
      </p>
      <p class="p2">
        <el-input type="text" v-model="title" placeholder="输入标题，20字以内" maxlength="20" show-word-limit></el-input>
      </p>
      <p class="p1">
        学段/学科：
        <span style="color:red">*</span>
      </p>
      <p class="p2">
        <el-select v-model="sectionValue" placeholder="学段/学科" style="width:160px;">
          <el-option v-for="item in sectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </p>
      <p class="p1">
        模式选择：
        <span style="color:red">*</span>
      </p>
      <p class="p3">
        <el-radio v-model="mode" @change="changeMode()" label="1">写作</el-radio>
        <el-radio v-model="mode" @change="changeMode()" label="2">文档</el-radio>
      </p>
      <div class="div1" v-if="mode == 1">
        <p class="p1" style="margin-top:20px;">
          文章内容：
          <span style="color:red">*</span>
        </p>
        <div class="div1">
          <quill-editor v-model="content1" :options="quillOption"></quill-editor>
        </div>
      </div>
      <div class="div2" v-if="mode == 2">
        <div class="p1">
          文档上传
          <span style="color:red">*</span>
          <span class="doc">支持word/ppt/excel/pdf格式</span>
        </div>
        <el-upload :action="uploadUrl" :data="uploadData" :on-success="onSuccess" :on-remove="onRemove"
          :before-upload="beforeUpload" :on-exceed="onExceed" :limit="fileLimit" :file-list="fileList"
          accept=".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .txt">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </div>
      <p class="p1" style="margin-top:20px;">
        权限：
        <span style="color:red">*</span>
      </p>
      <p class="p2">
        <el-radio v-model="permission_scope" label="1">公开</el-radio>
        <el-radio v-model="permission_scope" label="4">本校</el-radio>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="disabled2" @click="dialogVisible1 = true, subOk(1)">确定</el-button>
        <el-button class="white_btn" @click="dialogVisible1 = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 发布文章 -->

    <!-- 编辑文章 -->
    <el-dialog class="add_article_box" title="编辑文章" :closeOnClickModal="false" :visible.sync="dialogVisible2"
      width="700px">
      <p class="p1">
        标题：
        <span style="color:red">*</span>
      </p>
      <p class="p2">
        <el-input type="text" @keydown.native="changeEdit()" v-model="title" placeholder="输入标题20字以内" maxlength="20"
          show-word-limit></el-input>
      </p>
      <p class="p1">
        学段/学科：
        <span style="color:red">*</span>
      </p>
      <p class="p2">
        <el-select @change="changeEdit()" :disabled="disabled" v-model="sectionValue" placeholder="学段/学科"
          style="width:160px">
          <el-option v-for="item in sectionList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </p>

      <p class="p1">
        模式选择：
        <span style="color:red">*</span>
      </p>
      <p class="p3">
        <el-radio v-model="mode" @change="changeMode(), changeEdit()" label="1">写作</el-radio>
        <el-radio v-model="mode" @change="changeMode(), changeEdit()" label="2">文档</el-radio>
      </p>

      <div class="div1" v-if="mode == 1">
        <p class="p1" style="margin-top:20px;">
          文章内容：
          <span style="color:red">*</span>
        </p>
        <div class="div1">
          <quill-editor @keydown.native="changeEdit()" v-model="content2" :options="quillOption"></quill-editor>
        </div>
      </div>

      <div class="div2" v-if="mode == 2">
        <div class="p1">
          文档上传
          <span style="color:red">*</span>
          <span class="doc">支持word/ppt/excel/pdf格式</span>
        </div>
        <el-upload :action="uploadUrl" :data="uploadData" :on-success="onSuccess" :on-remove="onRemove"
          :before-upload="beforeUpload" :on-exceed="onExceed" :limit="fileLimit" :file-list="fileList"
          accept=".pdf, .doc, .docx, .ppt, .pptx, .xls, .xlsx, .txt">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </div>

      <p class="p1" style="margin-top:20px;">
        权限：
        <span style="color:red">*</span>
      </p>
      <p class="p2">
        <el-radio @change="changeEdit()" v-model="permission_scope" label="1">公开</el-radio>
        <el-radio @change="changeEdit()" v-model="permission_scope" label="4">本校</el-radio>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="disabled2" @click="dialogVisible2 = true, subOk(2)">确定</el-button>
        <el-button class="white_btn" @click="dialogVisible2 = false">取消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑文章 -->

    <!-- 删除资源-->
    <el-dialog title="提示" :visible.sync="dialogVisible3" width="300px" :center="true"
      style="margin-top: 30vh !important;">
      <span>确认删除该资源？</span>
      <br />
      <br />
      <span class="del-span">资源删除后将无法找回！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible3 = false, delArticleOk()">确 定</el-button>
        <el-button @click="dialogVisible3 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除资源-->
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
import quillConfig from "../common/quill-config.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "Seminar",
  data() {
    return {
      uploadUrl: "", // 文件上传地址
      uploadData: "", // 文件上传参数
      article_type: 3, // 资源类型(专题讨论))
      active1: "", // 点击数排序
      active2: "active", // 时间排序
      userid: 1, // 登陆者id
      isShow: false, // 是否显示缺省页
      isSelf: false, // 是否本人
      page: 1,
      pageSize: 10,
      count: 0,
      order_by: 0, // 默认时间排序
      articleList: [], // 资源列表
      sectionList: [], // 该教师下的所有学科
      sectionActive: "0,0", // 学段,学科(列表选中的值))
      sectionValue: "", // 学段,学科(下拉框选中的值)
      section: "", // 学段
      subject: "", // 学科
      yearData: [], // 学年列表
      termData: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "上学期",
        },
        {
          value: "2",
          label: "下学期",
        },
      ], // 学期列表
      year: "", // 学年
      term: "", // 学期
      title: "",
      permission_scope: "1", // 权限
      mode: "2", // 内容模式 1写作模式 2文档模式
      content1: "", // 内容(添加)
      content2: "", // 内容(编辑))
      dialogVisible1: false, // 发布
      dialogVisible2: false, // 编辑
      dialogVisible3: false, // 删除
      disabled: false, // 禁止选择/学段学科
      disabled2: true, // 编辑确定按钮
      role: "", // 权限
      identity: "", // 身份
      creator_type: 1, // 创建类型 1-教师 2-教研员
      quillOption: quillConfig,
      file: "", // 文件路径
      file_name: "", // 文件名称
      fileList: [], // 文件列表
      maxSize: 200, // 最大上传大小,单位(M)
      fileLimit: 1, // 限制个数
      extensions: ["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx"], // 允许上传的格式
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      owner_id: 0,
    };
  },

  components: {
    quillEditor,
  },

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  methods: {
    init() {
      // 获取当前学年/学期
      var date = globalApi.getYearTerm();
      this.year = ""; // 学年
      this.term = ""; // 学期
      this.owner_id = this.$route.query.userid; // 教师空间id
      if (this.owner_id == undefined) {
        this.$router.push("error");
        return false;
      }
      this.GetTeacherSection(); // 获取某个教师所教的所有学科
      this.getYearList(); // 获取学年
      this.getLoginUserInfo(); // 获取登录权限
    },
    // 内容模式切换
    changeMode() {
      this.content1 = "";
      this.content2 = "";
      this.file = "";
      this.fileList = [];
    },

    // 获取用的登录数据并存入localStorage
    async getLoginUserInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      this.isLogin = isLogin;
      if (isLogin) {
        this.userid = this.websiteSessionInfo.userid;
        this.isSelf = this.userid == this.owner_id;
        this.uploadUrl = globalApi.GetWebHost("upload"); // 文件上传地址
        this.uploadData = {
          UserId: this.userid,
          SessionKey: this.websiteSessionInfo.sessionKey,
          OS: 4,
          CheckCode: globalApi.randomString(40),
        };
      }
      this.GetAuth(); // 获取权限
      this.GetIdentity(); // 获取身份
      this.SearchArticle(); // 获取资源列表
    },

    // 删除弹窗提示
    delMsg(school) {
      this.$message({
        showClose: true,
        message: "请联系" + school + "管理员屏蔽后再删除。",
      });
    },

    // 分页导航
    PageChange(val) {
      this.page = val;
      this.SearchArticle(); // 获取资源文章
    },

    // 改变编辑状态
    changeEdit() {
      this.disabled2 = false;
    },

    // 学年搜索
    // type = 1 学年搜索
    // type = 2 学期搜索
    changeYear(type) {
      this.page = 1;
      if (this.year == 0) {
        this.term = "0";
        if (type == 2) {
          this.$message.error("请先选择学年!");
          return false;
        }
      }
      this.SearchArticle();
    },

    // 排序搜索
    changeActive(val) {
      this.page = 1;
      if (val == 1) {
        this.active1 = "active";
        this.active2 = "";
      } else {
        this.active1 = "";
        this.active2 = "active";
      }
      this.order_by = val;
      this.SearchArticle(); // 获取资源文章
    },

    // 切换学段/学科
    handleClick(val) {
      this.page = 1;
      var arr = this.sectionActive.split(",");
      this.section = arr[0];
      this.subject = arr[1];
      this.SearchArticle(); // 获取资源文章
    },

    // 获取权限
    async GetAuth() {
      const data = {
        s: "Common.Auth.getAuth",
        operator_id: this.userid, // 登陆者id
        user_id: this.owner_id, // 空间id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.role = res.data.data;
    },

    // 获取身份
    async GetIdentity() {
      const data = {
        s: "Common.Auth.getIdentity",
        user_id: this.userid, // 登陆者id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.identity = res.data.data;
    },

    // 获取学年接口
    async getYearList() {
      const data = {
        s: "WebSchoolSpace.Common.getYearList",
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.yearData = res.data.data;
    },

    // 获取某个教师所教的所有学科
    async GetTeacherSection() {
      const data = {
        s: "WebTeacherSpace.TeachingArticle.GetTeacherSection",
        userid: this.owner_id, // 教师空间id
      };
      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.sectionList = res.data.data;
    },

    // 获取某条资源文章的内容
    async GetArticleInfo() {
      const data = {
        s: "WebTeacherSpace.TeachingArticle.GetArticleInfo",
        operator_id: this.userid, // 登录id
        id: this.article_id, // 文章id
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }
      if (response == 1) {
        const info = res.data.data.info;
        this.title = info.title;
        this.mode = String(info.mode); // 内容模式
        this.content2 = info.content; // 内容
        this.sectionValue = info.section + "," + info.subjectid;
        this.permission_scope = String(info.permission_scope); // 权限
        this.file = info.file_resid; // 文件路径
        this.file_name = info.file_name; // 文件名称
        if (info.file_resid) {
          this.fileList = [{ name: info.file_name, url: "" }]; // 文件列表
        }
        var sectionList = Array();
        if (this.sectionList.length != undefined) {
          this.sectionList.forEach((item, index, array) => {
            sectionList.push(item.value);
          });
        }

        // 如果不存在
        if (sectionList.indexOf(this.sectionValue) == -1) {
          this.GetSectionSubjectById(info.section, info.subjectid); // 通过id获取科目/学段
        } else {
          this.disabled = false;
        }
      } else {
        this.$message.error("server error");
      }
    },

    // 获取资源列表
    async SearchArticle() {
      document.documentElement.scrollTop = 0;
      var status = this.isSelf ? 0 : 2; // 0=返回所有 1=返回待审批的数据 2=已审批通过的数据
      var delete_status = this.isSelf ? 1 : 0; // 1显示所有 0 删除的不显示
      var data = {
        s: "WebTeacherSpace.TeachingArticle.SearchArticle",
        operator_id: this.userid, // 登录id
        teacher_id: this.owner_id, // 教师空间id
        page: this.page,
        page_size: this.pageSize,
        year: this.year,
        term: this.term,
        section: this.section,
        subject: this.subject,
        order_by: this.order_by, // 排序
        article_type: this.article_type, // 资源类型
        delete_status: delete_status, // 是否显示删除的
        status: status, // 0=返回所有 1=返回待审批的数据 2=已审批通过的数据
        creator_type: this.creator_type, // 创建者类型 1-教师 2-教研员
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      this.count = res.data.data.recordcount;
      this.articleList = res.data.data.list;
      this.count == 0 ? (this.isShow = true) : (this.isShow = false);
    },

    // 新增文章接口
    async CreateArticle() {
      const data = {
        s: "WebTeacherSpace.TeachingArticle.CreateArticle",
        operator_id: this.userid, // 登录id
        teacher_id: this.owner_id, // 教师空间id
        article_type: this.article_type, // 资源类型
        section: this.section, // 学段id
        subject: this.subject, // 科目id
        title: this.title, // 标题
        mode: this.mode, // 模式 1-写作模式 2-文档模式
        content: this.content1, // 内容
        file: this.file, // 文件路径
        file_name: this.file_name, // 文件名称
        permission_scope: this.permission_scope, // 权限
        creator_type: this.creator_type, // 创建者类型 1-教师 2-教研员
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      if (response == 1) {
        this.dialogVisible1 = false;
        this.$message.success("文章添加成功!");
        this.clear(); // 清除数据
        this.SearchArticle(); // 获取资源列表
      } else {
        this.$message.error("文章添加失败!");
      }
    },

    // 编辑文章接口
    async ModifyArticle() {
      const data = {
        s: "WebTeacherSpace.TeachingArticle.ModifyArticle",
        operator_id: this.userid, // 登录id
        article_id: this.article_id, // 文章id
        section: this.section, // 学段id
        subject: this.subject, // 科目id
        title: this.title, // 标题
        mode: this.mode, // 模式 1-写作模式 2-文档模式
        content: this.content2, // 内容
        file: this.file, // 文件路径
        file_name: this.file_name, // 文件名称
        permission_scope: this.permission_scope, // 权限
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      if (response == 1) {
        this.$message.success("文章编辑成功!");
        this.clear(); // 清除数据
        this.dialogVisible2 = false;
        this.SearchArticle(); // 获取资源列表
      } else {
        this.$message.error("文章编辑失败!");
      }
    },

    // 删除文章接口
    async DeleteArticle() {
      const data = {
        s: "WebTeacherSpace.TeachingArticle.DeleteArticle",
        operator_id: this.userid,
        article_id: this.article_id, // 文章id
      };
      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }

      if (response == 1) {
        this.dialogVisible3 = false;
        this.$message.success("文章删除成功!");
        this.SearchArticle(); // 获取资源列表
      } else {
        this.$message.error("文章删除失败!");
      }
    },

    // 通过id获取科目/学段
    async GetSectionSubjectById(section, subject) {
      const data = {
        s: "WebSchoolSpace.Common.GetSectionSubjectById",
        section: section, // 学段id
        subject: subject, // 学科id
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      this.sectionValue = res;
      this.disabled = true;
    },

    // 点击添加按钮
    async addBtn() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.disabled2 = false;
      this.dialogVisible1 = true;
      this.clear();
    },

    // 添加/编辑文章点击确定
    // type = 1 - 添加
    // type = 2 - 编辑
    async subOk(type) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      if (this.title == false) {
        this.$message.error("标题不能为空!");
        return false;
      }
      if (this.sectionValue == false) {
        this.$message.error("请选择学段/学科!");
        return false;
      }

      // 写作模式内容不能为空
      // 添加 - 内容模式
      if (this.content1 == false && this.mode == 1 && type == 1) {
        this.$message.error("内容不能为空!");
        return false;
      }
      // 编辑 - 写作模式
      if (this.content2 == false && this.mode == 1 && type == 2) {
        this.$message.error("内容不能为空!");
        return false;
      }
      // 文档模式文件不能为空
      if (this.file == false && this.mode == 2) {
        this.$message.error("请上传文件!");
        return false;
      }

      var arr = this.sectionValue.split(",");
      this.section = arr[0];
      this.subject = arr[1];
      this.disabled2 = true;
      if (type == 1) {
        this.CreateArticle(); // 添加文章
      } else {
        this.ModifyArticle(); // 编辑文章
      }
    },

    // 点击编辑按钮
    async editBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.disabled2 = true;
      var identity_status = this.identity.identity_status;
      var school_id = this.identity.school_id;
      if (school_id == val.schoolid && identity_status == 1) {
        this.dialogVisible2 = true;
      } else {
        return false;
      }
      this.article_id = val.id;
      this.GetArticleInfo();
    },

    // 删除按钮
    async delArticleBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }

      var school_id = this.identity.school_id;
      if (
        val.schoolid !== school_id &&
        val.approve_status == 2 &&
        val.delete_by == 0
      ) {
        this.delMsg(val.school_name);
        return false;
      } else {
        this.dialogVisible3 = true;
        this.article_id = val.id; // 文章id
      }
    },

    // 删除文章确定
    async delArticleOk() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.DeleteArticle();
    },

    // 清除数据
    clear() {
      this.title = "";
      this.sectionValue = "";
      this.content1 = "";
      this.content2 = "";
      this.file = "";
      this.file_name = "";
      this.fileList = [];
      this.permission_scope = "1";
      this.section = 0;
      this.subject = 0;
      this.mode = "2";
    },

    // 跳转详情
    async toInfo(val) {
      var permission_scope = val.permission_scope;
      if (permission_scope != 1) {
        const is_login = await globalApi.CheckLoginUserStatus(this);
        if (!is_login) {
          this.$message.error("对不起,你没有该权限!");
          return;
        }
      }
      if (
        permission_scope == 1 ||
        this.identity.school_id == val.schoolid ||
        this.isSelf
      ) {
        globalApi.jumpPath(
          2,
          "school_activity_discussion_info",
          "act_id=" + val.id
        );
      } else if (!globalApi.IsLogIned() && permission_scope != 1) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
        return false;
      } else {
        this.$message.error("对不起,你没有该权限!");
      }
    },

    // 下载文件
    async download(file_url, file_name) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      window.location =
        globalApi.GetWebHost("private-api") +
        "/?s=WebTeacherSpace.TeachingArticle.download" +
        "&file_url=" +
        file_url +
        "&file_name=" +
        file_name;
    },

    // ********上传相关******

    // 检查格式
    // fileName 文件名称
    // extensions 允许上传的格式
    checkExtensions(fileName, extensions) {
      var format = fileName.split(".").pop().toLowerCase(); // 用户上传的文件格式

      // 把允许上传文件格式的数组转为字符串
      var s = extensions.join(",");

      var exp = new RegExp(format);
      if (!exp.test(extensions)) {
        this.$message.warning("请上传 " + s + " 的格式!");
        return false;
      }
    },

    // 上传文件之前的钩子
    beforeUpload(file) {
      this.uploadData.CheckCode = globalApi.randomString(40);
      this.disabled2 = true;
      if (file["size"] >= this.maxSize * 1024 * 1024) {
        this.$message.warning(
          file["name"] + " 文件大小不能大于" + this.maxSize + "M!"
        );
        return false;
      } else {
        return this.checkExtensions(file.name, this.extensions);
      }
    },

    // 上传成功
    onSuccess(response, file, fileList) {
      if (response.Result) {
        this.file = response.Data.Original; // 文件路径
        this.file_name = response.Data.Realname; // 文件名称
        this.disabled2 = false;
      } else {
        if (response.ErrCode != 4) {
          this.$message.error(response.Errstr);
        }
      }
    },

    // 文件超过个数提示
    onExceed(files, fileList) {
      this.$message.warning("最多上传" + this.fileLimit + "个文件");
    },

    // 文件列表移除文件时的钩子
    onRemove(file, fileList) {
      this.file = "";
      this.file_name = "";
      this.disabled2 = false;
    },
  },
};
</script>
<style>
@import url("../../assets/css/reset.css");
@import url("../../assets/css/quill.css");
</style>

<style lang="scss" scoped>
.el-button--small {
  padding: 9px 9px;
}
.clearfix {
  clear: both;
  overflow: hidden;
  zoom: 1;
}
.content {
  min-height: 800px;
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
}
.main {
  width: 1180px;
  padding-left: 20px;
  border-radius: 4px;
  margin: auto;
  padding-top: 20px;
}
.top-type {
  width: 100%;
  height: 48px;
  border-bottom: 1px solid #e9e9e9;
  line-height: 48px;
  margin-top: 20px;
  span {
    float: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    cursor: pointer;
    margin-right: 20px;
  }
  .active {
    color: #0088ff;
  }
  .el-select {
    width: 120px;
    float: right;
    margin-left: 20px;
  }
  .el-tabs {
    width: 800px;
    float: left;
    .el-tabs__active-bar {
      display: none;
    }
  }
}

.select-d {
  width: 1180px;
  height: 48px;
  line-height: 48px;
  margin-top: 15px;
  span {
    float: right;
    margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
  }
  .active {
    color: #0088ff;
  }
}
table {
  width: 1180px;
  text-align: center;
  tr {
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    height: 48px;
    line-height: 48px;
  }
  .first-tr {
    background: #e4e5e8;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    .td1 {
      text-align: left;
      padding-left: 50px;
    }
  }
  .second-tr {
    font-family: Microsoft YaHei;
    height: 60px;
    line-height: 60px;
    .limit {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .td-1 {
      p {
        font-size: 14px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        padding-left: 50px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 20rem;
      }
    }
    .td-2 {
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .td-3 {
      span {
        margin: 0 20px;
        cursor: pointer;
      }
    }
  }
}
.add_article_box {
  .el-dialog {
    margin-top: 50px !important;
    .el-dialog__header {
      text-align: center;
    }
    .p1 {
      margin-bottom: 10px;
    }
    .p2 {
      margin-bottom: 30px;
      .el-input {
        width: 500px;
      }
      .el-select {
        width: 120px;
        margin-right: 20px;
      }
    }

    .div2 {
      margin-top: 25px;
    }
  }
}
.move-p1 {
  margin-bottom: 20px;
}
</style>
<style lang="scss" scoped>
.el-tabs__nav-wrap::after {
  display: none;
}
.none {
  height: 480px;
  line-height: 620px;
  text-align: center;
  background: url(../../assets/img/home_img_2.png) no-repeat center 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  position: absolute;
  width: 1180px;
}
.select-d span {
  cursor: pointer;
}
.el-dialog__header {
  padding: 20px 20px 10px;
  text-align: center;
}
.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 25px 30px;
  text-align: center;
}
</style>
<style lang="scss">
.el-dialog__body {
  padding: 0px 20px 10px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.el-tabs__active-bar {
  background-color: #f6f9fa;
  display: none;
}
.el-tabs__nav-wrap::after {
  height: 0px;
}
.el-dialog__header {
  text-align: center;
}
.ql-editor {
  min-height: 200px;
  max-height: 250px;
}
.el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 25px 25px 30px;
}
</style>

